export default [
    //新生报名

    {
        path: 'student/register',
        component: require('@/views/Student/Register/Index').default,
    },
    // 学生列表
    {
        path: "student/list",
        component: require('@/views/Student/List/Index').default,
    },
    //学生信息
    {
        path: 'student/:id',
        component: require('@/views/Student/Show/Index').default,
    },
    {
        path: 'student/:id/file',
        component: require('@/views/Student/Show/File/Index').default,
    }
]
